import Meta from '@/utils/RouterMeta'
import Router from '@/utils/Router'
import {act, company, contract, empowerment, invoice, payment, user, waybill} from "~/router/private/crud"

const child = [
    //companies
    Router.instance({
        path: 'companies',
        name: 'companies',
        component: () => import('@/pages/company/index'),
        meta: Meta.instance({
            title: 'Покупатели',
            btnName: 'Покупатели',
            icon: 'mdi-account-group',
            permissions: ['manager', 'buhgalter', 'moderator', 'admin']
        })
    }),
    ...company,
    //contracts
    Router.instance({
        path: 'contracts',
        name: 'contracts',
        component: () => import('@/pages/contract/index'),
        meta: Meta.instance({
            title: 'Договора',
            btnName: 'Договора',
            icon: 'mdi-file-document-multiple',
            permissions: ['manager', 'buhgalter', 'moderator', 'admin']
        })
    }),
    ...contract,
    Router.instance({
        meta: Meta.instance({
            title: 'Отгрузочные документы',
            btnName: 'Отгрузочные документы',
            icon: 'mdi-file-document-multiple',
            permissions: ['manager', 'buhgalter', 'moderator', 'admin'],
            subGroup: true
        }),
        children: [
            Router.instance({
                path: 'waybills',
                name: 'waybills',
                component: () => import('@/pages/waybill/index.vue'),
                meta: Meta.instance({
                    title: 'ТТН',
                    btnName: 'ТТН',
                    icon: 'mdi-truck',
                    permissions: ['manager', 'buhgalter', 'moderator', 'admin']
                })
            }),
            ...waybill,
            Router.instance({
                path: 'procurations',
                name: 'procurations',
                component: () => import('@/pages/empowerment/index'),
                meta: Meta.instance({
                    title: 'Доверенность',
                    btnName: 'Доверенность',
                    icon: 'mdi-certificate',
                    permissions: ['manager', 'buhgalter', 'moderator', 'admin']
                })
            }),
            ...empowerment,
            Router.instance({
                path: 'invoices',
                name: 'invoices',
                component: () => import('@/pages/invoice/index'),
                meta: Meta.instance({
                    title: 'Счет фактура',
                    btnName: 'Счет фактура',
                    icon: 'mdi-cash',
                    permissions: ['manager', 'buhgalter', 'moderator', 'admin']
                })
            }),
            ...invoice,
        ]
    }),
    Router.instance({
        path: 'acts',
        name: 'acts',
        component: () => import('@/pages/act/index'),
        meta: Meta.instance({
            title: 'АКТ сверки',
            btnName: 'АКТ сверки',
            icon: 'mdi-text-box-check-outline',
            permissions: ['manager', 'buhgalter', 'moderator', 'admin']
        })
    }),
    Router.instance({
        path: 'calculations',
        name: 'calculations',
        component: () => import('@/pages/acts_calculated/create'),
        meta: Meta.instance({
            title: 'Расчет',
            btnName: 'Расчет',
            icon: 'mdi-calculator',
            permissions: ['manager', 'buhgalter', 'moderator', 'admin']
        })
    }),
    ...act,
    Router.instance({
        path: 'payments',
        name: 'payments',
        component: () => import('@/pages/payment/index'),
        meta: Meta.instance({
            title: 'ПЛАТЕЖИ',
            btnName: 'ПЛАТЕЖИ',
            icon: 'mdi-bank',
            permissions: ['manager', 'buhgalter', 'moderator', 'admin']
        })
    }),
    ...payment,
]

export const realization = [
    Router.instance({
        meta: Meta.instance({
            icon: 'mdi-water',
            title: 'РЕАЛИЗАЦИЯ',
            btnName: 'РЕАЛИЗАЦИЯ',
            permissions: ['manager', 'buhgalter', 'moderator', 'admin']
        }),
        children: child
    }),
    ...user
]